import React from 'react';
import { translate, Trans } from 'react-i18next';

import { Link } from 'react-router-dom';
import { Checkbox, Button, Form, Input, Grid, Header, Message, Label, Segment, Responsive } from 'semantic-ui-react';


import AuthUtils from 'utils/AuthUtils.js';
import { colors, fontSizes, spacings } from 'style';
import styleDef from './style.js';
import iosAppStoreImg from 'img/ios-appstore.png';
import googlePlayImg from 'img/google-play.png';

var style = {
    ...styleDef,
    createAct: {
        display: 'inline',
        color: colors.themeDarkerGrey,
        fontSize: fontSizes.bodyL,
        lineHeight: fontSizes.h4,
        // fontStyle: 'italic',
    },
    column: {
        // maxWidth: '400px'
    },
    termsField: {
        //textAlign: 'left',
        paddingTop: '16px',
        paddingBottom: '36px',
        display: 'flex'
    },
    termsCheckbox: {
        //verticalAlign: 'middle',
    },
    storeLinks: {
        position: 'relative',
        left: '50%',
        top: '0',
        marginLeft: '-168px',
        width: '336px',
        textAlign: 'center',
    },
    mobileStoreLink: {
        display: 'inline-block',
        height: spacings.large,
        padding: '0px',
    },
    storeLinkSpacer: {
        display: 'inline-block',
        width: spacings.tiny,
    }
};

const SignUp = ({ t,
    valid,
    email,
    password,
    passwordConfirm,
    publicComputer,
    //inviteCode, 
    terms,
    onSubmit,
    onEmailChange,
    onPasswordChange,
    onPasswordConfirmChange,
    onSetPublicComputer,
    //onInviteCodeChange, 
    onTermsChange,
    onBlur,
    emailError,
    passwordError,
    passwordConfirmError,
    //inviteCodeError, 
    termsError,
    error }) => (
        <Form style={style.form} noValidate onSubmit={onSubmit}>
            <Grid style={style.content}>
                <Grid.Row style={style.row}>
                    <Grid.Column style={style.bannerColumn} verticalAlign="top">
                        <div style={style.banner}>
                            <div style={style.welcome}>{t('Sign Up')}</div>
                            <br />
                            <div style={style.createAct}>{t('for your free Optimity account')}</div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column style={style.column} verticalAlign="middle">
                        <div style={style.inputLabel}>{t('Email Address')}</div>
                        <Form.Field style={style.field}>
                            <input
                                style={{
                                    ...style.input,
                                    ...(emailError.length ? style.inputError : {})
                                }}
                                type="text"
                                name="userEmail"
                                value={email}
                                onChange={onEmailChange}
                                onBlur={onBlur}
                                required
                            />
                            {emailError.length > 0 &&
                                <Label basic color="red" pointing style={style.errorLabelBottom}>{emailError}</Label>
                            }
                        </Form.Field>
                        <div style={style.inputLabel}>{t('Password')}</div>
                        <Form.Field style={style.field}>
                            <input
                                style={{
                                    ...style.input,
                                    ...(passwordError.length ? style.inputError : {})
                                }}
                                type="password"
                                name="userPassword"
                                value={password}
                                onChange={onPasswordChange}
                                onBlur={onBlur}
                                placeholder={t('Password must be at least {{length}} characters', { length: AuthUtils.minPasswordLength })}
                                required
                            />
                            {passwordError.length > 0 &&
                                <Label basic color="red" pointing style={style.errorLabelBottom}>{passwordError}</Label>
                            }
                        </Form.Field>
                        <div style={style.inputLabel}>{t('Confirm Password')}</div>
                        <Form.Field style={style.field}>
                            <input
                                style={{
                                    ...style.input,
                                    ...(passwordConfirmError.length ? style.inputError : {})
                                }}
                                type="password"
                                name="userPasswordConfirm"
                                value={passwordConfirm}
                                onChange={onPasswordConfirmChange}
                                onBlur={onBlur}
                                required
                            />
                            {passwordConfirmError.length > 0 &&
                                <Label basic color="red" pointing style={style.errorLabelBottom}>{passwordConfirmError}</Label>
                            }
                        </Form.Field>
                        <Form.Field style={style.fieldCheckbox}>
                            <Checkbox style={style.checkbox} 
                                onChange={onSetPublicComputer}
                                name={'publicComputer'} 
                                value={publicComputer}/>{t('Public Computer')}
                        </Form.Field>
                        {}
                        {error.length > 0 &&
                            <Message negative>{error}</Message>
                        }
                        <Form.Field style={style.termsField}>
                            <Trans i18nKey="terms">
                                <Checkbox style={style.checkbox} onChange={onTermsChange} value={terms} /> I agree to the <a href="https://myoptimity.com/terms" target="_blank" style={style.anchor}>Terms & Conditions</a> and <a href="https://myoptimity.com/privacy" target="_blank" style={style.anchor}>Privacy Policy</a>
                            </Trans>
                            {termsError.length > 0 &&
                                <Label basic color="red" pointing style={style.errorLabelBottom}>{termsError}</Label>
                            }
                        </Form.Field>
                        <Button style={valid ? style.blueButton : style.greyButton} type="submit" >{t('Get free account')}</Button>
                        <Responsive {...Responsive.onlyMobile}>
                            <Grid.Row style={style.topRow}>
                                <Grid.Column style={style.topLink} verticalAlign="top" textAlign='right'>
                                    <Trans i18nKey="already_a_user">
                                        Already have an account? <Link to='/login' style={style.anchor}>Log In</Link>
                                    </Trans>
                                </Grid.Column>
                            </Grid.Row>
                        </Responsive>
                        {/* <br />
                        <br />
                        <br />
                        <div style={style.storeLinks}>
                            <a href="https://link.myoptimity.com/ios" target="_blank">
                                <img src={iosAppStoreImg} className="img-responsive" style={style.mobileStoreLink} alt='' />
                            </a>
                            <div style={style.storeLinkSpacer} />
                            <a href="https://link.myoptimity.com/android" target="_blank">
                                <img src={googlePlayImg} className="img-responsive" style={style.mobileStoreLink} alt='' />
                            </a>
                        </div> */}
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column style={style.column} verticalAlign='bottom'>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Form>
    );

export default translate('authentication')(SignUp);



// WEBPACK FOOTER //
// ./src/modules/authentication/SignUp.js